export default `float n=1.+snoise3D(p), s=4., e;
    for(int i=0;i++<7;p.y-=20.*n)
      p.xz=.8-abs(p.xz),
      p.x < p.z?p=p.zyx:p,
      s*=e=2.1/min(dot(p,p),1.),
      p=abs(p)*e-n;
    return length(p)/s+1e-4;
  }`